<template>
  <div
    ref="html"
    class="wysiwyg"
    :class="{
      'bold-headings': hub.font_heading_bold,
      'uppercase-headings': hub.font_heading_uppercase,
      '@2xl:columns-2': cols === 2,
      '@2xl:columns-2 @3xl:columns-3': cols === 3
    }"
    v-html="html"></div>
</template>

<script>
import { mapState } from 'pinia'
import { useSystemStore } from '@/stores/system'
import Str from 'laravel-js-str'

export default {
  props: {
    html: {
      type: [null, String],
      required: true
    },
    cols: {
      type: Number,
      default: 1
    }
  },
  computed: {
    ...mapState(useSystemStore, ['hub'])
  },
  mounted() {
    Array.from(this.$refs.html.getElementsByTagName('a')).forEach((anchor) => {
      const url = anchor.getAttribute('href')
      if (!url || !(url.startsWith(window.location.origin) || url.startsWith('/'))) {
        return
      }
      const path = url.replace(window.location.origin, '')
      anchor.onclick = (e) => {
        if (e.metaKey || e.ctrlKey) {
          return
        }

        e.preventDefault()
        this.$router.push(path)
      }
    })

    const headingTags = ['h1', 'h2', 'h3']
    for (let h = 0; h < headingTags.length; h++) {
      Array.from(this.$refs.html.getElementsByTagName(headingTags[h]))
        .filter((h) => h.textContent?.trim())
        .forEach((heading) => {
          let id = heading.textContent.replaceAll('-', ' ').trim()

          if (id) {
            heading.setAttribute('id', Str.kebab(id))
          }
        })
    }
  }
}
</script>
